module.exports = __webpack_public_path__ + "static/media/message.4433f014.svg";